/* unplugin-vue-components disabled */import script from "./Hamburger.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hamburger.vue?vue&type=script&setup=true&lang=ts"

import "./Hamburger.vue?vue&type=style&index=0&id=631dd618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631dd618"]])

export default __exports__